const LOGIN_PATH = '/login';
const LOGOUT_PATH = '/logout';
const RESET_PASSWORD_PATH = `${LOGIN_PATH}/reset-password`;
const CHANGE_PASSWORD_PATH = '/change-password';
const SIGNUP_PATH = '/signup';
const COMPLETE_ACCOUNT_PATH = '/complete-account';
const VERIFICATION_EMAIL_PATH = '/verification-email';
const DONATIONS_PATH = '/';
const CHARITY_PATH = '/charities/:charityId';
const USERS_PATH = '/users';
const DOCUMENTS_PATH = '/documents';
const DOCUMENT_TYPE_PATH = `${DOCUMENTS_PATH}/:documentType`;
const CHARITY_VETTING_PATH = '/charity-vetting';
const VETTING_PROGRESS_PATH = '/vetting-progress';
const HELP_CENTER_PATH = '/help-center';
const SETTINGS_PATH = '/settings';

export {
  LOGIN_PATH,
  LOGOUT_PATH,
  RESET_PASSWORD_PATH,
  CHANGE_PASSWORD_PATH,
  SIGNUP_PATH,
  COMPLETE_ACCOUNT_PATH,
  VERIFICATION_EMAIL_PATH,
  DONATIONS_PATH,
  CHARITY_PATH,
  USERS_PATH,
  DOCUMENTS_PATH,
  DOCUMENT_TYPE_PATH,
  CHARITY_VETTING_PATH,
  VETTING_PROGRESS_PATH,
  HELP_CENTER_PATH,
  SETTINGS_PATH,
};
